<template>
  <!-- Container for the login form -->
  <div class="max-w-md mx-auto bg-white border border-solid rounded-lg shadow-lg border-neutral-300">
    <!-- Header section of the form -->
    <div class="p-4 bg-white border-b border-solid rounded-t-lg border-neutral-300">
      <h3 class="text-lg font-semibold text-neutral-800">Log ind</h3>
    </div>
    <!-- Body section of the form -->
    <div class="p-4">
      <!-- Form element with submit handler -->
      <form class="space-y-4" @submit.prevent="login">
        <!-- Username input field -->
        <div>
          <label for="username" class="block mb-1.5 text-sm font-medium text-neutral-900">Email eller brugernavn</label>
          <input
            type="text"
            name="username"
            id="username"
            v-model="username"
            class="bg-gray-50 border border-neutral-300 text-neutral-900 text-sm rounded-lg focus:ring-neutral-500 focus:border-neutral-500 block w-full p-2.5"
            placeholder="Indtast din email eller brugernavn"
            required
          />
        </div>
        <!-- Password input field -->
        <div>
          <label for="password" class="block mb-1.5 text-sm font-medium text-neutral-900">Kodeord</label>
          <input
            type="password"
            name="password"
            id="password"
            v-model="password"
            placeholder="Indtast dit kodeord"
            class="bg-gray-50 border border-neutral-300 text-neutral-900 text-sm rounded-lg focus:ring-neutral-500 focus:border-neutral-500 block w-full p-2.5"
            required
          />
        </div>
        <!-- Remember me checkbox and forgot password link -->
        <div class="flex justify-between">
          <div class="flex items-start">
            <div class="flex items-center h-5">
              <input
                id="remember"
                type="checkbox"
                v-model="rememberMe"
                class="w-4 h-4 border rounded text-neutral-700 border-neutral-300 bg-gray-50 focus:ring-0 focus:ring-orange-500"
              />
            </div>
            <label for="remember" class="text-sm font-medium ms-2 text-neutral-900">Husk mig</label>
          </div>
          <a href="https://provstitoender.dk/wp-login.php?action=lostpassword" class="text-sm text-blue-700 hover:underline">Glemt kodeord?</a>
        </div>
        <!-- Submit button -->
        <button type="submit" class="w-full text-white bg-green-600 hover:bg-green-700 font-medium rounded-lg text-sm px-5 py-2.5 text-center">
          Log ind
        </button>
        <!-- Registration link -->
        <div class="text-sm font-medium text-neutral-700">
          Ikke registreret?
          <a href="#" class="text-blue-700 hover:underline" @click.prevent="emit('show-registration')">Opret konto</a>
        </div>
      </form>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, defineEmits, inject } from "vue";

// Define custom events to emit
const emit = defineEmits(["login-success", "show-registration"]);

// Inject the authStore
const authStore = inject("authStore");

// Define reactive variables for form inputs
const username = ref("");
const password = ref("");
const rememberMe = ref(false);

// On component mount, check if there's a remembered user in localStorage
onMounted(() => {
  const rememberedUser = localStorage.getItem("rememberedUser");
  if (rememberedUser) {
    const { username: savedUsername, rememberMe: savedRememberMe } = JSON.parse(rememberedUser);
    username.value = savedUsername;
    rememberMe.value = savedRememberMe;
  }
});

// Login function to call the authStore's login method
const login = async () => {
  await authStore.login(username.value, password.value, rememberMe.value);
};
</script>